
import React, { useState, useRef,useEffect } from 'react';
import { 
  Box, Button, TextField, Typography, Link, Avatar, Paper, 
  Grid, IconButton, InputLabel, Select, MenuItem, FormControl, useMediaQuery} from '@mui/material';
  import { useNavigate, useLocation } from 'react-router-dom';
  import { useTheme } from '@mui/material/styles';
import { Delete as DeleteIcon, CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import background from '../assets/img/Login.jpg';
import topo from '../assets/img/Fundo.png';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Api from '../api/Api'
 

const RegisterScreen = () => {
   const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [regimes, setregimes] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
 

  useEffect(() => {
    document.title = "CADASTRO";
    fetchRegimes();
 
  }, []);


  const fetchRegimes = async () => {
    try {
      const response = await Api.ListRegime();
      if (Array.isArray(response)) {
        const formatado = response.map(item => ({
          value: item.id,
          label: item.descricao,
           
        }));
        setregimes(formatado);
        
       
      } else {
        toast('Formato de resposta inválido');
      }
    } catch (error) {
      toast('Erro ao buscar regimes: ' + error.message);
    }
  };




 


  const [empresa, setEmpresa] = useState({
    nome: '',
    nif: '',
    matricula: '',
    codigoDocumento: '',
    regime: '',
    endereco: '',
    telefone: '',
    telefone2: '',
    email: '',
    site: ''
  });





  // Estados para os dados do usuário
  const [usuario, setUsuario] = useState({
    nome: '',
    email: '',
    senha: '',
    confirmarSenha: ''
  });

  // Estado para o logo da empresa
  const [logoEmpresa, setLogoEmpresa] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const fileInputRef = useRef(null);

  // Estados para erros de validação
  const [errors, setErrors] = useState({
    empresa: {
      nome: '',
      nif: '',
      matricula: '',
      codigoDocumento: '',
       regime: '',
      endereco: '',
      telefone: '',
      telefone2: ''
    },
    usuario: {
      nome: '',
      email: '',
      senha: '',
      confirmarSenha: ''
    }
  });

  // Manipulador de mudanças para os campos da empresa
  const handleEmpresaChange = (e) => {
    const { name, value } = e.target;
    
    // Validação específica para campos numéricos
    if ((name === 'telefone' || name === 'telefone2') && value && !/^\d*$/.test(value)) {
      return; // Não atualiza se não for número
    }
    
    setEmpresa({
      ...empresa,
      [name]: value
    });
  };

  // Manipulador de mudanças para os campos do usuário
  const handleUsuarioChange = (e) => {
    const { name, value } = e.target;
    setUsuario({
      ...usuario,
      [name]: value
    });
  };

  // Manipulador para upload do logo
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoEmpresa(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Manipulador para remover o logo
  const handleRemoveLogo = () => {
    setLogoEmpresa(null);
    setLogoPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Função de validação do formulário
  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      empresa: {
        nome: '',
        nif: '',
        matricula: '',
        codigoDocumento: '',
        endereco: '',
        telefone: '',
        telefone2: ''
      },
      usuario: {
        nome: '',
        email: '',
        senha: '',
        confirmarSenha: ''
      }
    };

    // Validações da empresa
    if (!empresa.nome) {
      newErrors.empresa.nome = 'O nome da empresa é obrigatório';
      isValid = false;
    } else if (empresa.nome.length > 200) {
      newErrors.empresa.nome = 'Máximo de 200 caracteres';
      isValid = false;
    }

    if (!empresa.nif) {
      newErrors.empresa.nif = 'O NIF é obrigatório';
      isValid = false;
    } else if (empresa.nif.length < 10) {
      newErrors.empresa.nif = 'Mínimo de 10 caracteres';
      isValid = false;
    }

    if (!empresa.matricula) {
      newErrors.empresa.matricula = 'A matrícula é obrigatória';
      isValid = false;
    }

    if (!empresa.codigoDocumento) {
      newErrors.empresa.codigoDocumento = 'O código do documento é obrigatório';
      isValid = false;
    } else if (empresa.codigoDocumento.length > 4) {
      newErrors.empresa.codigoDocumento = 'Máximo de 4 caracteres';
      isValid = false;
    }

    if (!empresa.endereco) {
      newErrors.empresa.endereco = 'O endereço é obrigatório';
      isValid = false;
    } else if (empresa.endereco.length > 200) {
      newErrors.empresa.endereco = 'Máximo de 200 caracteres';
      isValid = false;
    }

    if (!empresa.telefone) {
      newErrors.empresa.telefone = 'O telefone é obrigatório';
      isValid = false;
    } else if (empresa.telefone.length > 9) {
      newErrors.empresa.telefone = 'Máximo de 9 caracteres';
      isValid = false;
    } else if (!/^\d+$/.test(empresa.telefone)) {
      newErrors.empresa.telefone = 'Somente números são permitidos';
      isValid = false;
    }
      if (!empresa.regime) {
      newErrors.empresa.regime = 'O regime é obrigatório';
      isValid = false;
    }

    if (empresa.telefone2 && empresa.telefone2.length > 9) {
      newErrors.empresa.telefone2 = 'Máximo de 9 caracteres';
      isValid = false;
    } else if (empresa.telefone2 && !/^\d+$/.test(empresa.telefone2)) {
      newErrors.empresa.telefone2 = 'Somente números são permitidos';
      isValid = false;
    }

    

   if (!usuario.nome) {
      newErrors.usuario.nome = 'O nome é obrigatório';
      isValid = false;
    }


    if (!usuario.email) {
      newErrors.usuario.email = 'O e-mail é obrigatório';
      isValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(usuario.email)) {
      newErrors.usuario.email = 'E-mail inválido';
      isValid = false;
    }

    if (!usuario.senha) {
      newErrors.usuario.senha = 'A senha é obrigatória';
      isValid = false;
    }
else if (!/^(?=.*[A-Z])(?=.*[\W_]).{6,}$/.test(usuario.senha)) {
    newErrors.usuario.senha = '6 caracteres, 1 maiúscula e 1 símbolo.';
  isValid = false;
}


    if (!usuario.confirmarSenha) {
      newErrors.usuario.confirmarSenha = 'Confirme a senha';
      isValid = false;
    } else if (usuario.senha !== usuario.confirmarSenha) {
      newErrors.usuario.confirmarSenha = 'As senhas não coincidem';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    
    if (validateForm()) {
      // Aqui você pode enviar os dados para a API
      const formData = new FormData();
      
      // Adiciona dados da empresa
      Object.entries(empresa).forEach(([key, value]) => {
        formData.append(`empresa[${key}]`, value);
      });
      
      // Adiciona dados do usuário
      Object.entries(usuario).forEach(([key, value]) => {
        formData.append(`usuario[${key}]`, value);
      });
      
      // Adiciona o logo se existir
      if (logoEmpresa) {
        formData.append('logo', logoEmpresa);
      }
      

 

 
  const dados = {
    nome: formData.get('empresa[nome]'),
    nif: formData.get('empresa[nif]'),
    matricula: formData.get('empresa[matricula]'),
    cod: formData.get('empresa[codigoDocumento]'),
    endereco: formData.get('empresa[endereco]'),
    telefone: formData.get('empresa[telefone]'),
    telefone2: formData.get('empresa[telefone2]'),
    email: formData.get('empresa[email]'),
    site: formData.get('empresa[site]'),
    
    
   // logo: formData.get('empresa[senha]'),
    id_regime: formData.get('empresa[regime]'),

    name: formData.get('usuario[nome]'),
    emailuser: formData.get('usuario[email]'),
    password: formData.get('usuario[senha]'),
   
  };

 
    try {
        const result = await Api.AddEmpresa(dados);
      if (result.success) {
        toast.success('Dados adicionado com sucesso');
        
        setTimeout(() => {
          navigate("/");
        }, 4000);
        
      }  

     else if (result.message === "NIF") {
       toast.error('Erro: Esse NIF já foi cadastrado');
      } 

     else if (result.message === "Nao tem BD") {
       toast.error('Erro: Não é possível adicionar novos usuários no momento, por favor tente mais tarde.');
      } 


      else if (result.message === "Erro ao adicionar") {
       toast.error('Erro: Por favor entre em contacto com o suporte');
      } 

      else if (result.message === "E-mail") {
       toast.error('Erro: O e-mail do usuário já foi cadastrado');
      } 
    else{
    toast.error(result.message );
      }     


      
    } catch (error) {
      toast.error(error);
    }

    } else {
      toast.error('Por favor, corrija os erros no formulário.');
    }
 setLoading(false);
  };

 return (
    <div>
      <Box
        sx={{
          minHeight: '96.5vh',
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: isSmallScreen ? 1 : 2,
        }}
      >
        <Paper
          elevation={5}
          sx={{
            height: 800,
            width: 1200,
            borderRadius: 3,
            overflow: 'hidden',
            position: 'relative',
            maxHeight: '90vh',
            overflowY: 'auto',
            mx: isSmallScreen ? 1 : 2,
          }}
        >
          <Box
            sx={{
              height: 40,
              backgroundImage: `url(${topo})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative',
            }}
          />
          <Box sx={{ p: isSmallScreen ? 1 : 3, pt: isSmallScreen ? 4 : 6 }}>
            <form onSubmit={handleSubmit}>
              {/* Título Dados da Empresa */}
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 3 }}>
           <Box sx={{ flex: 1, height: '1px', backgroundColor: 'gray' }} />
         
         <Typography variant="body2" sx={{ mx: 2, whiteSpace: 'nowrap' }}>
           Dados da Empresa
         </Typography>
         
          
           <Box sx={{ flex: 1, height: '1px', backgroundColor: 'gray' }} />
              </Box>
              
              {/* Seção Principal */}
              <Box sx={{ 
                display: 'flex', 
                flexDirection: isSmallScreen ? 'column' : 'row', 
                gap: isSmallScreen ? 2 : 4 
              }}>
                {/* Seção do Logo */}
                <Box sx={{ 
                  width: isSmallScreen ? '100%' : 200,
                  minHeight: isSmallScreen ? 'auto' : 240,
                  mb: isSmallScreen ? 2 : 0
                }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '50%',
                      border: '1px dashed #ccc',
                      borderRadius: 2,
                      p: 2,
                      position: 'relative',
                      minHeight: isSmallScreen ? 180 : 240,
                    }}
                  >
                    {logoPreview ? (
                      <>
                        <Avatar
                          src={logoPreview}
                          sx={{
                            width: isSmallScreen ? 150 : 200,
                            height: isSmallScreen ? 150 : 200,
                            mb: 2,
                          }}
                          variant="rounded"
                        />
                        <IconButton
                          color="error"
                          onClick={handleRemoveLogo}
                          sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            backgroundColor: 'rgba(255,255,255,0.7)',
                            '&:hover': {
                              backgroundColor: 'rgba(255,255,255,0.9)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </>
                    ) : (
                      <>
                        <CloudUploadIcon sx={{ fontSize: 50, color: '#ccc', mb: 2 }} />
                        <Typography variant="body2" color="textSecondary" align="center">
                          Clique para adicionar o logo da empresa
                        </Typography>
                      </>
                    )}
                    
                    <input
                      type="file"
                     accept=".jpg,.png,"
                      onChange={handleLogoUpload}
                      ref={fileInputRef}
                      style={{ display: 'none' }}
                    />
                    
                    <Button
                      variant="outlined"
                      component="span"
                      onClick={() => fileInputRef.current.click()}
                      sx={{ mt: 2 }}
                      fullWidth={isSmallScreen}
                    >
                      {logoPreview ? 'Alterar Logo' : 'Selecionar Logo'}
                    </Button>
                  </Box>
                </Box>

                {/* Seção dos Inputs da Empresa */}
                <Box sx={{ flex: 1 }}>
                  {/* Nome da empresa - linha inteira */}
                  <TextField
                    fullWidth
                    name="nome"
                    label="Nome da Empresa *"
                    variant="outlined"
                    margin="normal"
                    value={empresa.nome}
                    onChange={handleEmpresaChange}
                    error={!!errors.empresa.nome}
                    helperText={errors.empresa.nome}
                    sx={{ mb: 2 }}
                    InputProps={{
                      sx: { height: 40, fontSize: '14px' },
                    }}
                    InputLabelProps={{
                      sx: { fontSize: '12px' }
                    }}
                      inputProps={{
                      maxLength: 200   
                      }}
                  />
                  
                  {/* NIF e Matrícula - mesma linha */}
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: isSmallScreen ? 'column' : 'row', 
                    gap: 2, 
                    mb: 2 
                  }}>
                    <TextField
                      fullWidth
                      name="nif"
                      label="NIF *"
                      variant="outlined"
                      value={empresa.nif}
                      onChange={handleEmpresaChange}
                      error={!!errors.empresa.nif}
                      helperText={errors.empresa.nif}
                      InputProps={{
                        sx: { height: 40, fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        sx: { fontSize: '12px' },
                      }}
                        inputProps={{
                          minLength: 5, 
                         maxLength: 20   
                      }}
                    />
                    <TextField
                      fullWidth
                      name="matricula"
                      label="Matrícula *"
                      variant="outlined"
                      value={empresa.matricula}
                      onChange={handleEmpresaChange}
                      error={!!errors.empresa.matricula}
                      helperText={errors.empresa.matricula}
                      InputProps={{
                        sx: { height: 40, fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        sx: { fontSize: '12px' },
                      }}
                       inputProps={{
                          minLength: 5, 
                         maxLength: 20   
                      }}
                    />
                  </Box>
                  
                  {/* Telefone e Telefone 2 - mesma linha */}
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: isSmallScreen ? 'column' : 'row', 
                    gap: 2, 
                    mb: 2 
                  }}>
                    <TextField
                      fullWidth
                      name="telefone"
                      label="Telefone *"
                      variant="outlined"
                      value={empresa.telefone}
                      onChange={handleEmpresaChange}
                      error={!!errors.empresa.telefone}
                      helperText={errors.empresa.telefone}
                      InputProps={{
                        sx: { height: 40, fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        sx: { fontSize: '12px' },
                      }}
                       inputProps={{
                       
                         maxLength: 9   
                      }}
                    />
                    <TextField
                      fullWidth
                      name="telefone2"
                      label="Telefone 2"
                      variant="outlined"
                      value={empresa.telefone2}
                      onChange={handleEmpresaChange}
                      error={!!errors.empresa.telefone2}
                      helperText={errors.empresa.telefone2}
                      InputProps={{
                        sx: { height: 40, fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        sx: { fontSize: '12px' },
                      }}
                       inputProps={{
                        
                         maxLength: 9   
                      }}
                    />
                  </Box>
                  
                  {/* Código do Documento e Regime - mesma linha */}
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: isSmallScreen ? 'column' : 'row', 
                    gap: 2, 
                    mb: 2 
                  }}>
                    <TextField
                      fullWidth
                      name="codigoDocumento"
                      label="Código do Documento *"
                      variant="outlined"
                      value={empresa.codigoDocumento}
                      onChange={handleEmpresaChange}
                      error={!!errors.empresa.codigoDocumento}
                      helperText={errors.empresa.codigoDocumento}
                      InputProps={{
                        sx: { height: 40, fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        sx: { fontSize: '12px' },
                      }}
                       inputProps={{
                          minLength: 2, 
                         maxLength: 4   
                      }}
                    />
                    <FormControl fullWidth>
                      <InputLabel sx={{ fontSize: '12px' }}>Regime Tributário *</InputLabel>
                      <Select
                        name="regime"
                        value={empresa.regime}
                        onChange={handleEmpresaChange}
                        label="Regime *"
                        error={!!errors.empresa.regime}
                        sx={{
                          height: 40,
                          fontSize: '14px',
                          '.MuiSelect-select': {
                            paddingTop: '8px',
                            paddingBottom: '8px',
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              fontSize: '14px',
                            },
                          },
                        }}
                      >
                        {regimes.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.empresa.regime && (
                        <Typography variant="caption" color="error">
                          {errors.empresa.regime}
                        </Typography>
                      )}
                    </FormControl>
                  </Box>
                  
                  {/* Email e Site - mesma linha */}
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: isSmallScreen ? 'column' : 'row', 
                    gap: 2, 
                    mb: 2 
                  }}>
                    <TextField
                      fullWidth
                      name="email"
                      label="E-mail da Empresa"
                      variant="outlined"
                      value={empresa.email}
                      onChange={handleEmpresaChange}
                      InputProps={{
                        sx: { height: 40, fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        sx: { fontSize: '12px' },
                      }}
                       inputProps={{
                          
                         maxLength: 50   
                      }}
                    />
                    <TextField
                      fullWidth
                      name="site"
                      label="Site"
                      variant="outlined"
                      value={empresa.site}
                      onChange={handleEmpresaChange}
                      InputProps={{
                        sx: { height: 40, fontSize: '14px' },
                      }}
                      InputLabelProps={{
                        sx: { fontSize: '12px' },
                      }}
                       inputProps={{
                         
                         maxLength: 50   
                      }}
                    />
                  </Box>
                  
                  {/* Endereço - linha inteira */}
                  <TextField
                    fullWidth
                    name="endereco"
                    label="Endereço *"
                    variant="outlined"
                    margin="normal"
                    value={empresa.endereco}
                    onChange={handleEmpresaChange}
                    error={!!errors.empresa.endereco}
                    helperText={errors.empresa.endereco}
                    sx={{ mb: 2 }}
                    InputProps={{
                      sx: { height: 40, fontSize: '14px' },
                    }}
                    InputLabelProps={{
                      sx: { fontSize: '12px' },
                    }}
                     inputProps={{
                         
                         maxLength: 200   
                      }}
                  />
                </Box>
              </Box>

              {/* Título Dados do Usuário */}
    
      
<Box sx={{ display: 'flex', alignItems: 'center', mt: 4, mb: 2 }}>
  <Box sx={{ flex: 1, height: '1px', backgroundColor: 'gray' }} />
  <Typography variant="body2" sx={{ mx: 2, whiteSpace: 'nowrap' }}>
    Dados do Usuário
  </Typography>
  <Box sx={{ flex: 1, height: '1px', backgroundColor: 'gray' }} />
</Box>
 
{/* Dados do Usuário - Agora com 3 campos (e-mail, senha, confirmar senha) */}
<Grid container spacing={2}>
  {/* E-mail (linha inteira em telas pequenas, metade em telas maiores) */}
<Grid item xs={12} md={6}>
  <TextField
    fullWidth
    name="nome"
    label="Nome *"
    variant="outlined"
    margin="normal"
    value={usuario.nome}
    onChange={handleUsuarioChange}
    error={!!errors.usuario.nome}
    helperText={errors.usuario.nome}
    InputProps={{
           sx: { height: 40, width: isSmallScreen ? 320 : 272, fontSize: '14px' },
    }}
    InputLabelProps={{
      sx: { fontSize: '12px' },
    }}
    inputProps={{
      maxLength: 150,
    }}
  />
</Grid>




  <Grid item xs={12} md={6}>
    <TextField
      fullWidth
      name="email"
      label="E-mail do Usuário *"
      variant="outlined"
      margin="normal"
      value={usuario.email}
      onChange={handleUsuarioChange}
      error={!!errors.usuario.email}
      helperText={errors.usuario.email}
      InputProps={{
           sx: { height: 40, width:  isSmallScreen ? 320 : 272,fontSize: '14px' },
      }}
      InputLabelProps={{
        sx: { fontSize: '12px' },
      }}
      inputProps={{
        maxLength: 50   
      }}
    />
  </Grid>
  
  {/* Senha e Confirmar Senha (empilhados em telas pequenas, lado a lado em telas médias/grandes) */}
  <Grid item xs={12} sm={6} md={3}>
    <TextField
      fullWidth
      name="senha"
      label="Senha *"
      type="password"
      variant="outlined"
      margin="normal"
      value={usuario.senha}
      onChange={handleUsuarioChange}
      error={!!errors.usuario.senha}
      helperText={errors.usuario.senha}
      InputProps={{
          sx: { height: 40, width:  isSmallScreen ? 320 : 272,fontSize: '14px' },
      }}
      InputLabelProps={{
        sx: { fontSize: '12px' },
      }}
      inputProps={{
        minLength: 4, 
        maxLength: 20   
      }}

      
    />
  </Grid>
  
  <Grid item xs={12} sm={6} md={3}>
    <TextField
      fullWidth
      name="confirmarSenha"
      label="Confirmar Senha *"
      type="password"
      variant="outlined"
      margin="normal"
      value={usuario.confirmarSenha}
      onChange={handleUsuarioChange}
      error={!!errors.usuario.confirmarSenha}
      helperText={errors.usuario.confirmarSenha}
      InputProps={{
           sx: { height: 40, width:  isSmallScreen ? 320 : 272,fontSize: '14px' },
      }}
      InputLabelProps={{
        sx: { fontSize: '12px' },
      }}
      inputProps={{
        minLength: 4, 
        maxLength: 20   
      }}
    />
  </Grid>
</Grid>

    


              <Button
               loading={loading}
              disabled={loading}
                type="submit"
                variant="contained"
                fullWidth
                sx={{ mt: 3, mb: 2 }}
                size={isSmallScreen ? 'medium' : 'large'}
              >
                Cadastrar
              </Button>
            </form>

            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Link href="/" underline="hover">Já tem uma conta? Faça login</Link>
            </Box>
          </Box>
        </Paper>
      </Box>
      <ToastContainer />
    </div>
  );
};

export default RegisterScreen;